var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGroup01 = function SvgIconGroup01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_group-01_svg2__a",
    x1: 15.51,
    x2: 104.8,
    y1: 4.11,
    y2: 62.25,
    gradientTransform: "matrix(1 0 0 -1 0 102)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_group-01_svg2__a",
    id: "icon_group-01_svg2__b",
    x1: 12.75,
    x2: 102.03,
    y1: 8.35,
    y2: 66.49
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_group-01_svg2__a",
    id: "icon_group-01_svg2__c",
    x1: -5.84,
    x2: 83.44,
    y1: 36.91,
    y2: 95.05
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_group-01_svg2__a",
    id: "icon_group-01_svg2__d",
    x1: -11.83,
    x2: 77.45,
    y1: 46.1,
    y2: 104.24
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M58.19 69.05c4.38-2.74 7.3-7.6 7.31-13.15 0-8.56-6.94-15.5-15.5-15.5s-15.5 6.94-15.5 15.5c0 5.55 2.92 10.41 7.3 13.15-8.24 3.26-14.07 11.31-14.07 20.72v8.13c0 1.08.87 1.95 1.95 1.95h40.65c1.08 0 1.95-.87 1.95-1.95v-8.13c0-9.41-5.83-17.46-14.08-20.72ZM38.4 55.9c0-6.4 5.19-11.59 11.59-11.59S61.58 49.5 61.58 55.9 56.4 67.49 50 67.49h-.02c-6.4 0-11.58-5.19-11.58-11.59m29.97 40.05H31.63v-6.17c0-10.14 8.22-18.37 18.37-18.37s18.37 8.22 18.37 18.37z",
    style: {
      fill: "url(#icon_group-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.13 54.75a22.2 22.2 0 0 0-11.22-9.78c4.39-2.74 7.31-7.6 7.32-13.15 0-8.56-6.94-15.5-15.5-15.5s-15.5 6.94-15.5 15.5c0 5.55 2.92 10.41 7.3 13.15-.93.37-1.85.8-2.74 1.31-.93.53-1.26 1.71-.73 2.65.52.94 1.71 1.27 2.66.75 2.75-1.55 5.85-2.36 9.01-2.36 10.15 0 18.38 8.22 18.38 18.37v6.17H71.42c-1.08 0-1.95.87-1.95 1.95s.87 1.95 1.95 1.95h26.64c1.08 0 1.95-.87 1.95-1.95v-8.13c0-3.83-.99-7.59-2.87-10.93ZM66.12 31.81c0-6.4 5.19-11.59 11.59-11.59S89.3 25.41 89.3 31.81c0 6.36-5.13 11.53-11.48 11.59h-.2c-6.36-.05-11.5-5.22-11.5-11.59",
    style: {
      fill: "url(#icon_group-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.55 73.81c0-1.08-.87-1.95-1.95-1.95H3.9v-6.17c0-3.15.81-6.26 2.36-9.01 3.35-5.96 9.54-9.32 15.92-9.36h.15c3.04 0 6.12.77 8.95 2.36a1.951 1.951 0 1 0 1.92-3.4c-.89-.5-1.81-.94-2.75-1.31 4.38-2.74 7.31-7.6 7.31-13.15 0-8.56-6.94-15.5-15.5-15.5s-15.5 6.94-15.5 15.5c0 5.55 2.92 10.41 7.3 13.15C5.83 48.23 0 56.27 0 65.68v8.13c0 1.08.87 1.95 1.95 1.95h26.64c1.08 0 1.95-.87 1.95-1.95Zm-19.87-42c0-6.4 5.19-11.59 11.59-11.59s11.59 5.19 11.59 11.59S28.67 43.4 22.27 43.4s-11.59-5.19-11.59-11.59",
    style: {
      fill: "url(#icon_group-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 31.15c8.56 0 15.49-6.94 15.5-15.5C65.5 7.08 58.56.14 50 .14s-15.5 6.94-15.5 15.5 6.94 15.5 15.5 15.5Zm0-27.1c6.4 0 11.59 5.19 11.59 11.59S56.4 27.23 50 27.23s-11.59-5.19-11.59-11.59S43.6 4.05 50 4.05",
    style: {
      fill: "url(#icon_group-01_svg2__d)"
    }
  }));
};
export default SvgIconGroup01;